import React, { useState } from 'react';
import type Trip from '@this/domain/trip/trip2';
import { Button } from '@this/components/shared/ui/inputs/button';
import OrganizationModal from './organization_modal';

interface Props {
  trip: Trip;
}

export const OrganizationInfoButton: React.FC<Props> = ({ trip }) => {
  const [showOrganizationModal, setShowOrganizationModal] = useState(false);
  const organizationId = trip?.user?.organization?.id;

  if (!organizationId) {
    return null;
  }

  return (
    <section>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ marginBottom: '4px' }}>企業情報</h3>
        <Button onClick={() => setShowOrganizationModal(true)}>企業情報</Button>
      </div>
      <OrganizationModal
        show={showOrganizationModal}
        organizationId={organizationId}
        onClose={() => setShowOrganizationModal(false)}
      />
    </section>
  );
};
